import React from 'react'
// import PropTypes from 'prop-types'

import { MainTitle, TextContent } from '../../../Shared';

const ApiAuthentication = props => {
  return (
    <div>
      <MainTitle>API Authentication</MainTitle>
      <TextContent>
        Currently, BK Traffic APIs were opened to use. You don't need authentication or authorization.
      </TextContent>
    </div>
  )
}

ApiAuthentication.propTypes = {

}

export default ApiAuthentication
